import styled, { css } from 'styled-components'

export const Container = styled.div`
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  margin: 80px 0;
  min-height: calc(100vh - 262px);
  width: 100%;
`

export const StepOneContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 388px 1fr;
  margin: 1.5rem 0 0;
  width: 100%;
`

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem 0 0;
  max-width: 400px;
  width: 100%;
`

export const InputContainer = styled.div`
  ${({ wrap }) => css`
    display: flex;
    gap: 15px;
    justify-content: center;
    flex-wrap: ${wrap ? 'wrap' : 'nowrap'};
    margin: 10px 0;
    width: 100%;
  `}
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1.5rem 0 0;
  width: 100%;
  gap: 16px;
`

export const LeftContent = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  row-gap: 115px;

  padding: 0 40px 0 0;
  width: 100%;
`

export const RightContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const InfoCard = styled.div`
  align-items: center;
  background-color: #d5ecfb;
  display: flex;
  flex-direction: column;
  height: 155px;
  justify-content: center;
  width: 188px;
`

export const FinishContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 45px 0;
  width: 388px;
`

export const PlanCard = styled.div`
  ${({ selected }) => css`
    align-items: center;
    border: 1px solid #d4d4d4;
    border-radius: var(--border-radius-lg);
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 24px 16px;
    min-width: 220px;
    max-width: calc(100vw - 32px);

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      transition: all 0.3s;
    }

    ${selected &&
    css`
      background-color: rgba(0, 0, 0, 0.1);
      color: #fff;
    `}
  `}
`

export const PriceContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`
